<div class="search-container">
    <img class="search-icon" src="/assets/icons/search.svg" alt="Search" />
    <input
        #inputField
        type="text"
        [formControl]="searchControl"
        [placeholder]="placeholder"
        class="search-input"
    />
</div>
